<template>
  <base-modal-bottom
    ref="modal"
    class="modal-withdraw-order-limit-rate has-text-centered"
    :isFooter="true"
    :title="title"
    :withClickOverlay="false"
    :btnClose="false"
  >
    <div class="margin-bottom">
      <base-icon width="64" height="64" name="time-24h" />
    </div>

    <div class="margin-bottom title-message">
      <p>
        <strong>Limite de tentativas excedido</strong>
      </p>
    </div>

    <p class="subtitle-message margin-bottom">
      Oops! Parece que hoje você excedeu o limite de tentativas de saque.
    </p>
    <p class="subtitle-message">
      Por favor, tente novamente amanhã ou entre em contato com o nosso time de
      atendimento para maiores informações.
    </p>

    <template #footer>
      <base-button-bottom
        @click.native="close"
        class="is-primary is-big"
        type="button"
      >
        Ok, entendi!
      </base-button-bottom>
    </template>
  </base-modal-bottom>
</template>

<script>
import BaseModalBottom from '@/components/BaseModalBottom.vue'
import BaseButtonBottom from '@/components/BaseButtonBottom.vue'

export default {
  components: {
    BaseModalBottom,
    BaseButtonBottom,
  },

  props: {
    title: {
      type: String,
      default: 'Validacão de segurança',
    },
  },

  methods: {
    open() {
      this.$refs.modal.open()
    },
    close() {
      this.$refs.modal.close()
      this.$emit('onClose')
    },
  },
}
</script>

<style lang="scss">
.modal-withdraw-order-limit-rate {
  .title-message,
  .subtitle-message,
  strong {
    max-width: 429px;
    margin: 0 auto;
    font-size: 16px;
    color: $neutral;
  }
}
</style>
